import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Event,NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import { Observable } from 'rxjs';
import { merge ,fromEvent } from 'rxjs';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.css']
})
export class DefaultComponent implements OnInit {

  // idleTime:number = 0;

  // count:number = 0;

  public loading:boolean = false;

  constructor(private userIdle: UserIdleService,
    private router:Router) { 

      // this.router.events.subscribe((event:Event)=>{

      //   switch (true) {
      //     case event instanceof NavigationStart: {
      //       this.loading = true;
      //       break;
      //     }
  
      //     case event instanceof NavigationEnd:
      //     case event instanceof NavigationCancel:
      //     case event instanceof NavigationError: {
      //       this.loading = false;
      //       break;
      //     }
      //     default: {
      //       break;
      //     }
      //   }
      // });
    }

  ngOnInit(): void {
    
    // localStorage.removeItem('idleTime');

    //  //Start watching for user inactivity.
    //  this.userIdle.startWatching();
    
    //  // Start watching when user idle is starting.
    //  this.userIdle.onTimerStart().subscribe(count => {
    //     this.count = count;
    //     console.log(count);
    //  });
     
    //  // Start watch when time is up.
    //  this.userIdle.onTimeout().subscribe(() => {
    //     this.idleTime = + localStorage.getItem('idleTime');
    //     (this.idleTime != undefined && this.idleTime != null)? this.idleTime : this.idleTime = 0;
    //      this.idleTime = this.count+1;
    //      localStorage.setItem('idleTime',this.idleTime.toString());
    //      this.count = 0;
    //      console.log('Time is up!')
    //      this.restart();
    //  }
    //  );

  }

  // stop() { 
  //   this.userIdle.stopTimer();
  // }
 
  // stopWatching() {
  //   this.userIdle.stopWatching();
  // }
 
  // startWatching() {
  //   this.userIdle.startWatching();
  // }
 
  // restart() {
  //   this.userIdle.resetTimer();
  // }


  @HostListener('window:scroll',['$event'])

  onWindowScroll(){

      if(window.pageYOffset > 5){
        document.querySelector('.header').classList.add('headerboxShadow');
      }else{
        document.querySelector('.header').classList.remove('headerboxShadow');
      }
  }

}
